import React from "react";
import { Button } from "gumdrops";
import { ModalContext } from "../utils/modalContext";

const ModalExample = ({ actionTitle, title, content, size, context }) => {
  let { handleModal } = React.useContext(ModalContext);

  return (
    <>
      <Button
        size={size}
        context={context}
        onClick={() => handleModal({ title, content })}
      >
        {actionTitle}
      </Button>
    </>
  );
};

export default ModalExample;
